/* Koleksiyon sayfası etkileşimleri: sıralama, grid/list, filtre */
(function () {
  'use strict';

  // Sıralama: seçim değişince sort_by ile yönlendir (mevcut filtreleri koru)
  const sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  }

  // Grid / Liste görünümü
  const grid = document.querySelector('[data-product-grid]');
  document.querySelectorAll('[data-view]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const view = btn.getAttribute('data-view');
      document.querySelectorAll('[data-view]').forEach((b) => b.classList.toggle('is-active', b === btn));
      if (grid) grid.classList.toggle('product-grid--list', view === 'list');
      try { localStorage.setItem('collection-view', view); } catch (e) {}
    });
  });
  // Kayıtlı görünümü uygula
  try {
    const saved = localStorage.getItem('collection-view');
    if (saved === 'list') {
      const b = document.querySelector('[data-view="list"]');
      if (b) b.click();
    }
  } catch (e) {}

  // Filtre formu: herhangi bir giriş değişince formu gönder (sunucu filtreli koleksiyonu render eder)
  const form = document.querySelector('[data-filter-form]');
  if (form) {
    const submit = (window.Theme && window.Theme.debounce ? window.Theme.debounce(() => form.submit(), 500) : () => form.submit());
    form.addEventListener('change', (e) => {
      if (e.target.matches('[data-filter-input]')) submit();
    });
  }
})();
